<div id="questionario-page">

    <div class="container" *ngIf="formRicerca">
        <div>
            <div class="header-custom d-flex flex-column justify-content-center align-items-center">
                <div class="img-container">
                    <div class="img">
                        <img src="../../../assets/images/logo_unisa_color.png" alt="logo_unisa">
                    </div>
                    <h1>UNIVERSITÀ DEGLI STUDI DI SALERNO</h1>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center mt-5">
                    <h2>Opinioni Studenti - Questionari 2 e 4 ANVUR</h2>

                    <h3 class="mt-3">Parte A - Corso di studi, aule e attrezzature e servizi di supporto</h3>
                </div>
            </div>
            <div class="body-custom p-4 bg-white">
                <form [formGroup]="formRicerca" class="form-row">
        
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>Anno Accademico</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="annoAccademico"
                            id="annoAccademico" fullWidth (change)="findDipa(); loadTableSettings()">
                            <option [value]="anno.annoFormattato1" *ngFor="let anno of arrayAnni">{{anno.annoFormattato2}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>Studenti</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="studente"
                            id="studente" fullWidth (change)="findDipa(); loadTableSettings()">
                            <option value="Frequentanti">Frequentanti</option>
                            <option value="Non frequentanti">Non Frequentanti</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>Dipartimento</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="dipartimento"
                            id="dipartimento" fullWidth (change)="findCds(); loadTableSettings()">
                            <option value="*">TUTTI</option>
                            <option [value]="d.descrizioneDipartimento" *ngFor="let d of listaDipa" [hidden]="d.descrizioneDipartimento=='Tutti'">{{d.descrizioneDipartimento}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>CDS</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="cds"
                            id="cds" fullWidth (change)="loadTableSettings()">
                            <option value="*">TUTTI</option>
                            <option [value]="cds.descrizioneCdsCompleta" *ngFor="let cds of listaCds" [hidden]="cds.descrizioneCdsCompleta=='Tutti'">{{cds.descrizioneCdsCompleta}}</option>
                        </select>
                    </div>
                </form>
        
                <div style="overflow-x: auto;">
                    <ng2-smart-table *ngIf="settings" id="table" #table [settings]="settings" [source]="source">
                    </ng2-smart-table>
                </div>
        
                <div class="legenda-wrapper mt-3 d-flex flex-row align-items-center justify-content-center ">
                    <p> <strong>DN</strong> = Decisamente No, </p>
                    <p> <strong>PNCS</strong> = Più No che Si, </p>
                    <p> <strong>PSCN</strong> = Più Si che No, </p>
                    <p> <strong>DS</strong> = Decisamente Si </p>
                </div>
        
                <div class="d-flex flex-column pt-3">
                    <div class="d-flex justify-content-center align-items-center">
                        <h5 class="m-0"><strong>DOMANDE</strong></h5>
                        <button nbButton (click)="toggleDomande()" class="btn btn-primary d-flex align-items-center ml-2">
                            <i class="fas fs-20" [class]="{'fa-eye': viewDomande, 'fa-eye-slash': !viewDomande}" title="{{viewDomande?'nascondi' : 'visualizza'}} domande"></i>
                        </button>
                    </div>
                    <div class="table-domande" [class]="{'close': !viewDomande}">
                        <ng2-smart-table id="tableDomande" [settings]="settingsDomande" [source]="arrayDomande"></ng2-smart-table>
                    </div>
                </div>
                
                <hr *ngIf="!viewDomande">

                <div echarts [options]="optionGraph" class="echart" style="margin-top: 40px;"></div>
            </div>
        </div>
    </div>
</div>
